import React from "react";
import "./itens.css";
import { IoMdRemoveCircleOutline } from "react-icons/io";

type DynamicEditableTableProps = {
  columns: string[];
  fieldsMap: string[];
  rows: any[];
  onChange: (rows: any[]) => void;
  isFieldDisabled?: () => boolean;
  placeholders?: Record<string, string>;
};

export default function DynamicEditableTable({
  columns,
  fieldsMap,
  rows,
  onChange,
  isFieldDisabled,
  placeholders = {},
}: DynamicEditableTableProps) {
  const MAX_ROWS = 5;

  const handleAddRow = () => {
    if (rows.length < MAX_ROWS) {
      onChange([...rows, Object.fromEntries(fieldsMap.map((f) => [f, ""]))]);
    }
  };

  const handleRemoveRow = (index: number) => {
    onChange(rows.filter((_, i) => i !== index));
  };

  const handleChange = (index: number, field: string, value: string) => {
    const updated = [...rows];
    updated[index][field] = value;
    onChange(updated);
  };

  return (
    <div className="overflow-x-auto">
      <table className="custom-table">
        <thead>
          <tr>
            {columns.map((col, idx) => (
              <th key={idx}>{col}</th>
            ))}
            <th style={{ width: "80px", textAlign: "center" }}></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {fieldsMap.map((field, colIndex) => (
                <td key={colIndex}>
                  <div style={{ position: "relative" }}>
                    <textarea
                      id={`${field}-${rowIndex}`}
                      value={row[field] || ""}
                      placeholder={
                        placeholders[field]
                          ? placeholders[field]
                          : `Insira aqui ${columns[colIndex].toLowerCase()}`
                      }
                      onChange={(e) =>
                        handleChange(rowIndex, field, e.target.value)
                      }
                      className="textarea-modern"
                      maxLength={500}
                      rows={3}
                      disabled={isFieldDisabled ? isFieldDisabled() : false}
                      style={{
                        width: "100%",
                        minHeight: "80px",
                        borderRadius: 8,
                        border: "1.5px solid #e0e0e0",
                        padding: "10px",
                        fontSize: "1.1rem",
                        background: "#f5f5f5",
                        transition: "border 0.2s, box-shadow 0.2s",
                        boxShadow: "0 1px 6px #0001",
                        resize: "vertical",
                        outline: "none",
                      }}
                      onFocus={(e) =>
                        (e.currentTarget.style.borderColor = "#00b894")
                      }
                      onBlur={(e) =>
                        (e.currentTarget.style.borderColor = "#e0e0e0")
                      }
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        fontSize: "0.8em",
                        marginTop: 4,
                        color: "#888",
                      }}
                    >
                      {(row[field] || "").length}/500
                    </div>
                  </div>
                </td>
              ))}

              <td className="text-center align-middle">
                <button
                  type="button"
                  onClick={() => handleRemoveRow(rowIndex)}
                  className="btn-remove"
                  disabled={isFieldDisabled ? isFieldDisabled() : false}
                >
                  <IoMdRemoveCircleOutline color="red" size={20} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="add-row-container">
        <button
          type="button"
          onClick={handleAddRow}
          className={`${rows.length >= MAX_ROWS ? "btn-limit" : "btn-modern "}`}
          disabled={
            isFieldDisabled ? isFieldDisabled() : false || rows.length >= MAX_ROWS
          }
        >
          {rows.length >= MAX_ROWS
            ? `Limite de ${MAX_ROWS} linhas atingido`
            : "+ Adicionar nova linha"}
        </button>
      </div>
    </div>
  );
}
